export default __webpack_public_path__ + "static/media/18.38883693.png";